export default "__VITE_ASSET__31d0686a__"